import PageHeader from '../../components/common/PageHeader';
import DocumentVerification, {
  Document,
} from '../../components/ib/DocumentVerification';
import ComplianceTracking, {
  ComplianceRecord,
} from '../../components/ib/ComplianceTracking';
import KycStatusCards from '../../components/ib/KycStatusCards';

const IBKyc = () => {
  const documents: Document[] = [
    {
      id: '1',
      name: 'Passport',
      type: 'passport',
      status: 'uploaded',
      uploadedDate: '2024-01-15',
      fileUrl: '',
    },
    {
      id: '2',
      name: 'National ID Card',
      type: 'id-card',
      status: 'pending',
      uploadedDate: '2024-01-10',
      fileUrl: '',
    },
    {
      id: '3',
      name: 'Address Proof',
      type: 'address-proof',
      status: 'pending',
      uploadedDate: '',
      fileUrl: '',
    },
    {
      id: '4',
      name: 'Tax Document',
      type: 'tax-document',
      status: 'pending',
      uploadedDate: '',
      fileUrl: '',
    },
  ];

  const complianceRecords: ComplianceRecord[] = [
    {
      id: '1',
      type: 'AML Compliance',
      status: 'compliant',
      lastChecked: '2024-01-15',
    },
    {
      id: '2',
      type: 'PEP Screening',
      status: 'compliant',
      lastChecked: '2024-01-15',
    },
    {
      id: '3',
      type: 'Sanctions Check',
      status: 'pending',
      lastChecked: '2024-01-10',
    },
  ];

  const statusCards = [
    {
      title: 'Verification Status',
      value: 'In Progress',
      subtitle: '2 of 4 documents',
      icon: 'clock' as const,
      iconColor: 'yellow' as const,
    },
    {
      title: 'Compliance Score',
      value: '85%',
      subtitle: 'Good standing',
      icon: 'check' as const,
      iconColor: 'green' as const,
    },
    {
      title: 'Last Updated',
      value: 'Jan 15',
      subtitle: '2024',
      icon: 'file' as const,
      iconColor: 'blue' as const,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="sticky top-0 z-20 bg-background pt-4">
        <PageHeader
          title="KYC Verification"
          description="Complete your verification to access all features"
        />
      </div>

      <KycStatusCards cards={statusCards} />
      <DocumentVerification documents={documents} />
      <ComplianceTracking records={complianceRecords} />
    </div>
  );
};

export default IBKyc;
